import { render, staticRenderFns } from "./PoiOpenClosedIcons.vue?vue&type=template&id=21481f7f"
import script from "./PoiOpenClosedIcons.js?vue&type=script&lang=js&external"
export * from "./PoiOpenClosedIcons.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports